import dayjs from 'dayjs'

type SessionTimerLike = {
  start: (initial?: number) => void
  stop: () => void
}

export const getLocalConferenceStart = (
  appointmentTimestampStart: number,
  eventTimestamp: number,
): number => {
  const now = dayjs.tz().unix()
  return appointmentTimestampStart + (now - eventTimestamp)
}

export const getConferenceTimerOffsetSeconds = (startTimestamp: number): number => {
  return dayjs.tz().unix() - startTimestamp
}

export const startConferenceAwareSessionTimer = (
  timer: SessionTimerLike,
  isGroup: boolean,
  pServedUser: string,
  startedCallsTimestamps: ReadonlyMap<string, number>,
): void => {
  const startTimestamp = isGroup ? startedCallsTimestamps.get(pServedUser) : undefined

  timer.stop()

  if (startTimestamp) {
    timer.start(getConferenceTimerOffsetSeconds(startTimestamp))
    return
  }

  timer.start()
}
